export enum SyncShopifyProductsForTeamResponse {
  STARTED = "STARTED",
  ALREADY_IN_PROGRESS = "ALREADY_IN_PROGRESS",
}

export interface ProductForSync {
  collections: { handle: string; id: string; title: string }[];
  description: string;
  handle: string;
  /** gid://shopify/Product/123 */
  id: string;
  image: { src: string | null; altText: string | null };
  metafields: Record<string, string>;
  priceRange: {
    maxVariantPrice: { amount: string; currencyCode: string };
    minVariantPrice: { amount: string; currencyCode: string };
  };
  publishedToOnlineStore: boolean;
  status: string;
  tags: string[];
  title: string;
  totalInventory: number;
  vendor: string | undefined;
  productType: string | undefined;
  variants: ProductVariantForSync[];
  updatedAt: string;
}

export const ONLINE_STORE_SALES_CHANNEL_NAME = "Online Store";

/** Stands in for the publication id when a shop has no Online Store publication; the check is skipped then. */
export const FALLBACK_PUBLICATION_ID = "gid://shopify/Publication/0";

interface ResourcePublicationNode {
  publication: {
    id: string;
    name?: string | null;
    catalog?: { title?: string | null } | null;
  };
}

/**
 * Matches on both catalog title and publication name because the catalog
 * title can be undefined.
 */
export function findOnlineStorePublication(
  resourcePublications: readonly ResourcePublicationNode[],
): ResourcePublicationNode["publication"] | undefined {
  return resourcePublications.find(
    ({ publication }) =>
      publication.catalog?.title === ONLINE_STORE_SALES_CHANNEL_NAME ||
      publication.name === ONLINE_STORE_SALES_CHANNEL_NAME,
  )?.publication;
}

export const ONLINE_STORE_CHANNEL_HANDLE = "online_store";

export interface ProductVariantForSync {
  availableForSale: boolean;
  barcode: string | null;
  grams: number;
  displayName: string;
  id: string;
  image: { src: string | null; altText: string | null };
  inventory_policy: string;
  inventory_quantity: number;
  metafields: Record<string, string>;
  price: string;
  sku: string;
  taxCode: string | undefined;
  title: string;
}
